import styled from "styled-components";
import { px2rem } from "../../utils/css";
export const Container = styled.section `
	padding: ${(props) => {
    if (props.columnSize === 1) {
        return `${px2rem(12)} ${px2rem(12)} 0 `;
    }
    return `${px2rem(9)} ${px2rem(12)} 0 `;
}};
	overflow-x: scroll;
	scrollbar-width: none;
`;
export const BtnWrapper = styled.div `
	width: fit-content;
	padding-right: ${px2rem(12)};
`;
export const InnerBox = styled.div `
	display: grid;
	${(props) => props.grid};

	::-webkit-scrollbar {
		display: none;
	}
`;
export const CodeBtn = styled.button `
	background-image: ${(props) => `url(${props.imgUrl})`};
	border: none;
	background-size: contain;
	:focus {
		outline: none;
	}
`;
